import React, {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';

interface Props{
	next: () => void
}

var About = ({next}: Props) => {
	const [title, setTitle] = useState('');
	const [content, setContent] = useState('');	
	useEffect(() => {
		fetch('/wp-json/wp/v2/pages?slug=star-warps-an-online-book-of-art-inspired-by-star-wars/')
		.then(response => response.json())
		.then(data => {
			setTitle(data[0].title.rendered);
			setContent(data[0].content.rendered);
		});	
	}, []);
	return (
		<div className="about">
			<div>
				<h1>{title}</h1>
				<div
					dangerouslySetInnerHTML={{
						__html: content
					}}
				/>
			</div>
		</div>
	);
}
export default About;